import * as React from "react";
const SvgCheckbox = () => /* @__PURE__ */ React.createElement("svg", { width: 36, height: 36, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.11 4.696A16 16 0 0 1 18 2a16.047 16.047 0 0 1 16 16A16 16 0 1 1 9.11 4.696m17.578 6.928c.48.483.48 1.266 0 1.749L15.394 24.738l-6.082-6.12a1.24 1.24 0 0 1 0-1.748 1.223 1.223 0 0 1 1.738 0l4.344 4.37 9.556-9.616a1.223 1.223 0 0 1 1.738 0",
    clipRule: "evenodd"
  }
));
export default SvgCheckbox;
